import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  color: "字体颜色",
  bgColor: "背景颜色",
  opacity: "透明度",
  borderTypeFlag: "圆角类型", // 1:单独设置  2:全部设置
  borderRadius: "圆角",
  borderTopLeftRadius: "边框左上角圆角",
  borderTopRightRadius: "边框右上角圆角",
  borderBottomLeftRadius: "边框左下角圆角",
  borderBottomRightRadius: "边框右下角圆角",
  borderStyle: "边框类型", // solid dashed dotted
  borderColor: "边框颜色",
  borderWidth: "边框宽度",
  borderIsThemeColor: "边框颜色为主题色",
  boxShadowColor: "边框阴影颜色",
  boxShadowH: "阴影x轴的偏移量",
  boxShadowV: "阴影y轴的偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值",
  paddingTypeFlag: "边距类型",
  padding: "内边距",
  paddingTop: "上内边距",
  paddingRight: "右内边距",
  paddingLeft: "左内边距",
  paddingBottom: "下内边距",
  showTitle: "显示标题",
  dateStyle: "日期格式",
  titleFontFamily: "标题字体",
  titleFontSize: "标题字体大小",
  titleFontWeight: "标题字重",
  titleFontStyle: "标题字体样式",
  titleTextDecoration: "标题下划线",
  titleLineHeight: "标题行高",
  titleLetterSpacing: "标题字间距",
  titleWritingMode: "标题排列方式",
  titleTextAlign: "标题对齐方式",
  titleTextIsThemeColor: "标题字体颜色跟随主题色",
  titleColor: "标题颜色",
  fontFamily: "字体",
  fontSize: "字体大小",
  fontWeight: "字重",
  fontStyle: "字体样式",
  textDecoration: "下划线",
  lineHeight: "行高",
  letterSpacing: "字间距",
  writingMode: "排列方式",
  textAlign: "对齐方式",
  textIsThemeColor: "字体颜色跟随主题色",
  titleBgColorIsThemeColor: "标题背景颜色跟随主题色",
  titleBgColor: "标题背景颜色",
  titlePaddingTypeFlag: "标题边距类型",
  titlePadding: "标题内边距",
  titlePaddingTop: "标题上内边距",
  titlePaddingRight: "标题右内边距",
  titlePaddingBottom: "标题左内边距",
  titlePaddingLeft: "标题下内边距",
  showLunar: "显示日历",
  firstDayOfWeek: "周起始日",
  weekColor: "星期颜色",
  weekFontFamily: "星期字体",
  weekFontSize: "星期字体大小",
  weekFontWeight: "星期字重",
  weekBgColorIsThemeColor: "星期背景颜色跟随主题色",
  weekBgColor: "星期背景颜色",
  lunarColor: "农历颜色",
  lunarFontFamily: "农历字体",
  lunarFontSize: "农历字体大小",
  lunarFontWeight: "农历字重",
  showNotCurrentDate: "隐藏非本月日期",
  notCurrentTextIsThemeColor: "非本月日期颜色跟随主题色",
  notCurrentTextColor: "非本月日期颜色",
  hoverColor: "悬浮颜色",
  hoverFontFamily: "悬浮字体",
  hoverFontSize: "悬浮字体大小",
  hoverFontWeight: "悬浮字体字重",
  hoverBorderTypeFlag: "悬浮圆角类型", // 1:单独设置  2:全部设置
  hoverBorderRadius: "悬浮圆角",
  hoverBorderTopLeftRadius: "悬浮边框左上角圆角",
  hoverBorderTopRightRadius: "悬浮边框右上角圆角",
  hoverBorderBottomRightRadius: "悬浮边框左下角圆角",
  hoverBorderBottomLeftRadius: "悬浮边框右下角圆角",
  hoverBgColorIsThemeColor: "悬浮背景颜色跟随主题色",
  hoverBgColor: "悬浮背景颜色",
  hoverBorderStyle: "悬浮边框类型", // solid dashed dotted
  hoverBorderColor: "悬浮边框颜色",
  hoverBorderWidth: "悬浮边框宽度",
  hoverBorderIsThemeColor: "悬浮边框颜色为主题色",
  showHoverBorder: "显示悬浮边框",

  activeColor: "选中颜色",
  activeFontFamily: "选中字体",
  activeFontSize: "选中字体大小",
  activeFontWeight: "选中字体字重",
  activeBorderTypeFlag: "选中圆角类型", // 1:单独设置  2:全部设置
  activeBorderRadius: "选中圆角",
  activeBorderTopLeftRadius: "选中边框左上角圆角",
  activeBorderTopRightRadius: "选中边框右上角圆角",
  activeBorderBottomRightRadius: "选中边框左下角圆角",
  activeBorderBottomLeftRadius: "选中边框右下角圆角",
  activeBgColorIsThemeColor: "选中背景颜色跟随主题色",
  activeBgColor: "选中背景颜色",
  activeBorderStyle: "选中边框类型", // solid dashed dotted
  activeBorderColor: "选中边框颜色",
  activeBorderWidth: "选中边框宽度",
  activeBorderIsThemeColor: "选中边框颜色为主题色",
  showActiveBorder: "显示选中边框",

  datePaddingTopVal: "日期上边距",
  datePaddingBottomVal: "日期下边距",

  showTodayStyle: "显示今日样式",
  todayStyleColor: "今日样式颜色",
  todayStyleFontFamily: "今日样式字体",
  todayStyleFontSize: "今日样式字体大小",
  todayStyleFontWeight: "今日样式字重",
  todayStyleBorderTypeFlag: "今日样式圆角类型", // 1:单独设置  2:全部设置
  todayStyleBorderRadius: "今日样式圆角",
  todayStyleBorderTopLeftRadius: "今日样式边框左上角圆角",
  todayStyleBorderTopRightRadius: "今日样式边框右上角圆角",
  todayStyleBorderBottomRightRadius: "今日样式边框左下角圆角",
  todayStyleBorderBottomLeftRadius: "今日样式边框右下角圆角",
  todayStyleBorderIsThemeColor: "今日样式边框颜色为主题色",
  todayStyleBorderColor: "今日样式边框颜色",
  todayStyleBorderStyle: "今日样式边框类型", // solid dashed dotted
  todayStyleBorderWidth: "今日样式边框宽度",
  todayStyleBgColorIsThemeColor: "今日样式背景颜色跟随主题色",
  todayStyleBgColor: "今日样式背景颜色",
  showTodayStyleBorder: "显示今日样式边框",

  showActivityMark: "显示活动标记",
  activityWidth: "活动标记大小",
  activityColorIsThemeColor: "活动标记颜色为主题色",
  activityColor: "活动标记颜色",

  showButton: "显示切换按钮",
  iconSrc: "图标链接",
  buttonIconType: "图标类型", // img icon
  iconColorIsThemeColor: "图标颜色跟随主题色",
  buttonIconColor: "按钮颜色",
  iconResInfo: "图标描述",
  buttonIconSize: "按钮大小",
  iconBgIsThemeColor: "图标背景颜色跟随主题色",
  buttonIconBackgroundColor: "按钮背景色",
  buttonIconBackgroundWidth: "按钮背景色宽度",
  buttonIconBackgroundHeight: "按钮背景色高度",
  buttonIconBackGroundBorderRadius: "按钮背景色圆角",
  buttonBoxShadowH: "按钮阴影x轴的偏移量",
  buttonBoxShadowV: "按钮阴影y轴的偏移量",
  buttonBoxShadowBlur: "按钮阴影模糊值",
  buttonBoxShadowSpread: "按钮阴影扩散值",
  buttonBoxShadowColor: "按钮边框阴影颜色",
  buttonIconCustomTop: "自定义按钮位置",
  buttonIconPadding: "按钮内边距",
  buttonIconTop: "按钮上边距",
  leftButtonIconX: "左边按钮X轴偏移量",
  leftButtonIconY: "左边按钮Y轴偏移量",
  rightButtonIconX: "右边按钮X轴偏移量",
  rightButtonIconY: "右边按钮Y轴偏移量",

  legendPosition: "图例位置",
  showTodayLegend: "显示今日图例",
  todayLegendVal: "今日图例内容",
  todayLegendColor: "今日图例颜色",
  todayLegendFontFamily: "今日图例字体",
  todayLegendFontSize: "今日图例字体大小",
  todayLegendFontWeight: "今日图例字重",
  todayLegendBorderWidth: "今日图例边框宽度",
  todayLegendBorderIsThemeColor: "今日图例边框颜色跟随主题色",
  todayLegendBorderColor: "今日图例边框颜色",
  todayLegendBgColor: "今日图例背景颜色",
  todayLegendBgType: "今日图例类型",
  todayLegendShapeType: "今日图例图片形状",
  todayLegendBorderRadius: "今日图例圆角",
  todayLegendWidth: "今日图例宽",
  todayLegendHeight: "今日图例高",

  showActivityLegend: "显示活动图例",
  activityLegendVal: "活动图例内容",
  activityLegendColor: "活动图例颜色",
  activityLegendFontFamily: "活动图例字体",
  activityLegendFontSize: "活动图例字体大小",
  activityLegendFontWeight: "活动图例字重",
  activityLegendBorderWidth: "活动图例边框宽度",
  activityLegendBorderIsThemeColor: "活动图例边框颜色跟随主题色",
  activityLegendBorderColor: "活动图例边框颜色",
  activityLegendBgColor: "活动图例背景颜色",
  activityLegendBgType: "活动图例类型",
  activityLegendShapeType: "活动图例图片形状",
  activityLegendBorderRadius: "活动图例圆角",
  activityLegendWidth: "活动图例宽",
  activityLegendHeight: "活动图例高",
  legendSpace: "图例间距",
  legendPaddingTypeFlag: "图例边距类型",
  legendPadding: "图例内边距",
  legendPaddingTop: "图例上内边距",
  legendPaddingRight: "图例右内边距",
  legendPaddingBottom: "图例左内边距",
  legendPaddingLeft: "图例下内边距",
  selectedDates: "有活动的日期列表",
  relativeComponentId: "关联组件id",
  startDateFlag: "关联组件开始日期标记",
  endDateFlag: "关联组件结束日期标记",



}
export const getOptDes = toSelectOpt.bind(this, optDes)
